import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FileText, MessageCircle, Phone } from "lucide-react";
import { PHONE_LINK, WHATSAPP_LINK } from "../../lib/constants";
import { trackEvent } from "../../lib/api";
import { quoteHref } from "../../data/homeContent";
import { PRODUCT_PAGES } from "../../data/products";

const HIDDEN_ON = ["/offerte-aanvragen", "/offerte-bedankt"];
const FIELDS = "input:not([type=checkbox]):not([type=radio]):not([type=range]), textarea, select";

// Verbergt de balk zolang een invoerveld actief is (toetsenbord open), zodat formulieren en verzendknoppen vrij blijven.
const useTyping = () => {
  const [typing, setTyping] = useState(false);
  useEffect(() => {
    const on = (e) => e.target.matches?.(FIELDS) && setTyping(true);
    const off = () => setTimeout(() => setTyping(Boolean(document.activeElement?.matches?.(FIELDS))), 50);
    document.addEventListener("focusin", on);
    document.addEventListener("focusout", off);
    return () => { document.removeEventListener("focusin", on); document.removeEventListener("focusout", off); };
  }, []);
  return typing;
};

export const MobileContactBar = () => {
  const { pathname } = useLocation();
  const typing = useTyping();
  const [badge, setBadge] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setBadge(Boolean(document.getElementById("emergent-badge"))), 1500);
    return () => clearTimeout(t);
  }, []);
  if (HIDDEN_ON.includes(pathname) || typing) return null;
  const onderwerp = PRODUCT_PAGES.find((p) => p.path === pathname)?.onderwerp;
  const item = "flex min-h-[46px] flex-col items-center justify-center gap-0.5 rounded-xl text-[12.5px] font-semibold";
  return (
    <nav aria-label="Snel contact" data-testid="mobile-contact-bar"
      className={`fixed inset-x-0 bottom-0 z-40 flex gap-1.5 border-t border-slate-200 bg-white/95 px-2 pt-1.5 pb-[calc(0.375rem+env(safe-area-inset-bottom,0px))] backdrop-blur md:hidden ${badge ? "pr-[150px]" : ""}`}>
      <Link to={quoteHref(onderwerp)} state={{ from: pathname }} onClick={() => trackEvent("cta_quote_click", { location: "mobile_bar" })}
        className={`${item} flex-[1.7] bg-maas text-white shadow-[0_8px_18px_-10px_rgba(14,119,125,0.8)] hover:bg-maas-hover`} data-testid="mobile-bar-quote">
        <FileText className="h-5 w-5" aria-hidden="true" /> Offerte
      </Link>
      <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent("click_whatsapp", { page_type: "mobile_bar" })} className={`${item} flex-1 text-ink hover:bg-slate-50`} data-testid="mobile-bar-whatsapp">
        <MessageCircle className="h-5 w-5 text-whatsapp" aria-hidden="true" /> WhatsApp
      </a>
      <a href={PHONE_LINK} onClick={() => trackEvent("click_phone", { page_type: "mobile_bar" })} className={`${item} flex-1 text-ink hover:bg-slate-50`} data-testid="mobile-bar-call">
        <Phone className="h-5 w-5 text-maas" aria-hidden="true" /> Bellen
      </a>
    </nav>
  );
};
